import { Directive, effect, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { OrganizationService } from '../services/organization.service';
import { PermissionService } from '../services/permission.service';
import { ToastService } from '../services/toast.service';

@Directive({
  selector: '[readOnlyIfNoGroupPermissionDirective]',
  standalone: true
})
export class ReadOnlyIfNoGroupPermissionDirectiveDirective implements OnChanges {
  @Input() showToastWhenRendering: boolean = true; // Allow toggling toast visibility
  @Input() componentDisabled: boolean = false; // New input to track component's disabled state

  private currentState: { hasPermission: boolean; componentDisabled: boolean } = {
    hasPermission: false,
    componentDisabled: false
  };

  constructor(
    private organizationService: OrganizationService,
    private permissionService: PermissionService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private toastService: ToastService) // Assuming you have a ToastService for showing messages) {
  {
    effect(() => {
      const organizationId = this.organizationService.currentOrganizationId;
      const hasPermission = organizationId && this.permissionService.hasElevatedPermission(organizationId);

      // Update current state
      this.currentState.hasPermission = hasPermission as boolean;

      // Re-evaluate button state
      this.updateButtonState();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['componentDisabled']) {
      this.currentState.componentDisabled = changes['componentDisabled'].currentValue;
      this.updateButtonState();
    }
  }

private updateButtonState(): void {
    const { hasPermission, componentDisabled } = this.currentState;

    if (hasPermission && !componentDisabled) {
      // Enable if user has permission AND component doesn't disable it
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
      this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');
    } else {
      // Disable if no permission OR component wants it disabled
      this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
      if (!hasPermission && this.showToastWhenRendering) {
        this.showToast();
      }
    }
  }

  private showToast() {
    this.toastService.show('Permission Denied', 'This form is read-only because you lack the required permissions.', 'danger', 3000);
  }
}
